import HttpService from "./HttpService";
const API_ENDPOINT = "/general-setting";

const GeneralInformation = {
  async fetchGeneralInformation() {
    try {
      // The backend resolves the division (branding, theme) from the app URL
      // the user is browsing, e.g. https://abc.example.com
      const response = await HttpService.get(`${API_ENDPOINT}`, {
        params: { base_url: window.location.origin },
      });
      return response?.data;
    } catch (error) {
      console.error("unable to fetch general information:", error);
      throw error?.response?.data || error;
    }
  },
  async saveGeneralSetting(formData) {
    try {
      const response = await HttpService.post(`${API_ENDPOINT}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
      })
      return response?.data;
    } catch (error) {
      console.error("eror", error);
      throw error?.response?.data || error;
    }
  },
  async updateGeneralSetting(id, formData) {
    formData.append('_method', 'PUT');
    try {
      const response = await HttpService.post(`${API_ENDPOINT}/setting/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
      })
      return response?.data;
    } catch (error) {
      console.error("eror", error);
      throw error?.response?.data || error;
    }
  },
  async organizationSetting(formData) {
    try {
      const response = await HttpService.post(`${API_ENDPOINT}/organization-settings`, formData); 
      return response?.data;
    } catch (error) {
      console.error("error", error);
      throw error?.response?.data || error;
    }
  },
  async fetchModules() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/module-permission`); 
      return response?.data;
    } catch (error) {
      console.error("error", error);
      throw error?.response?.data || error;
    }
  },
  async giveModuleAccess(data) {
    try {
      const response = await HttpService.post(`${API_ENDPOINT}/module-permission`, data); 
      return response?.data;
    } catch (error) {
      console.error("error", error);
      throw error?.response?.data || error;
    }
  },
  async uploadBulkEmployee(data) {
    try {
      const response = await HttpService.post(`${API_ENDPOINT}/upload-bulk-employee`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response?.data;
    } catch (error) {
      console.error("Bulk employee upload error:", error);
      throw error?.response?.data || error;
    }
  },
  async downloadSampleSheet() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/download-bulk-employee`);
      return response?.data;
    } catch (error) {
      console.error("Sample sheet download error: ", error);
      throw error?.response?.data || error;
    }
  },
  async getErrors() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/error-list`);
      return response?.data;
    } catch (error) {
      console.error("Sample sheet download error: ", error);
      throw error?.response?.data || error;
    }
  },
   async getUsers(params = {}) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/users`, {
        params,
      });
      return response?.data;
    } catch (error) {
      console.error("Get users error:", error);
      throw error?.response?.data || error;
    }
  },
  async getRoles() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/roles`);
      return response?.data;
    } catch (error) {
      console.error("Get roles error:", error);
      throw error?.response?.data || error;
    }
  },
  async addRole(data) {
    try {
      const response = await HttpService.post(`${API_ENDPOINT}/role-permssion`, data); 
      return response?.data;
    } catch (error) {
      console.error("error", error);
      throw error?.response?.data || error;
    }
  },
  async assignRole(payload) {
    try {
      const response = await HttpService.post(
        `${API_ENDPOINT}/assign-role`,
        {
          employee_personal_id: payload.employee_personal_id,
          role_id: payload.role_id,
        }
      );
      return response?.data;
    } catch (error) {
      console.error("Assign role error:", error);
      throw error?.response?.data || error;
    }
  },
  async getModulePermissions() {
    try {
      const response = await HttpService.get(
        `${API_ENDPOINT}/modular-permissions`
      );
      return response?.data;
    } catch (error) {
      console.error("Get module permission error:", error);
      throw error?.response?.data || error;
    }
  },
  async saveModulePermissions(payload) {
    try {
      const response = await HttpService.post(
        `${API_ENDPOINT}/module-permission`,
        payload
      );
      return response?.data;
    } catch (error) {
      console.error("Save module permission error:", error);
      throw error?.response?.data || error;
    }
  },
  async fetchSystemStatus() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/is-installed`);
      return response?.data;
    } catch (error) {
      console.error("unable to fetch system status:", error);
      throw error?.response?.data || error;
    }
  },
  async updateSystemStatus() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/installation-complete`);
      return response?.data;
    } catch (error) {
      console.error("invalid response:", error);
      throw error?.response?.data || error;
    }
  },
};
export default GeneralInformation;